import React, { Component } from 'react'
import { connect } from 'react-redux'

import RevenueShareList from '../../components/RevenueShareList'
import SubPartnersList from '../../components/SubPartnersList'
import PageWrapper from '../../components/PageWrapper'
import BulkRevshareModal from '../../components/BulkRevshareModal'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'
import { Preloader } from '../../components/Chart/index'
import debounce from 'lodash/debounce'
import './style.css'

import Multi from '../../components/Multi'
import { uniqueDmps } from '../../lib/format-dmps'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import RoundBlueButton from '../../components/BorderButton/round-blue-button'
import SessionService from '../../lib/services/SessionService'




// modal styling

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        position: 'absolute',
        width: 600,
        backgroundColor: 'white',
        border: '1px solid #000',
        boxShadow: '1px solid ',
        padding: '10px'
    }
}

const SaveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="saveBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-floppy-o" />} />
)
const RemoveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="deleteBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash" />} />
)

class Settings extends Component {
    debouncedFilter = null

    state = {
        revshares: [],
        revshareSize: 20,
        revshareOffset: 0,
        revshareFilter: '',
        revshareSort: 'partnerId,dmp,product',
        revshareSortOrder: 'desc',
        revshareFilter: "",

        loading: false,
        data: null,
        canCreateSubPartners: true,
        dmpList: [],
        dmpProducts: [],

        showSellerModal: false,
        sellerPartnersList: [],
        modalStyle: {},

        showBulkRevhsareModal: false,
        
        subpartnersOffset: 0,
        subpartnersSize: 20,
        subPartnersFilter: "",
        subPartners: [],

        showRevshareListNonAdmin: false,



    }

    componentDidMount() {
        let partnerLogged = SessionService.getPartnerLogged()
        if( partnerLogged && partnerLogged.partnerId !== 'p-admin' ) {
            this.setState({showRevshareListNonAdmin: true})
        }
        
        // load modal styles
        this.setState({
            modalStyle: getModalStyle(),
        })

        
        this.loadPartners()

        let canCreateSubPartners = true;
        let partnerMasquerading = SessionService.getPartnerMasqueraded()
        if (partnerMasquerading != null && partnerMasquerading.hasOwnProperty('canCreateChildren')) {
            canCreateSubPartners = partnerMasquerading.canCreateChildren
        }
        this.setState({ canCreateSubPartners: canCreateSubPartners })
    

        this.debouncedRevshareFilter = debounce(this.loadRevShares, 300)
        this.debouncedPartnersFilter = debounce(this.loadPartners, 300)
    }


    loadPartners(filter='', subpartnersOffset=0, subpartnersSize = 20, reset = true){
        axios.get('/partner?offset='+subpartnersOffset+'&size='+subpartnersSize+'&filter=' + filter).then(response => {
            console.log('get partner ', response.data)

            let data = response.data.body[0] || {}
            let partnerSettings = data.partnerSettings || {}
            let subPartnerSettings = []
            if(reset){
                if(data && data.subPartnerSettings){
                    subPartnerSettings = data.subPartnerSettings
                }
            } else {
                subPartnerSettings = this.state.subPartnerSettings
                if(data && data.subPartnerSettings){
                    subPartnerSettings = subPartnerSettings.concat(data.subPartnerSettings) 
                }
            }
            this.setState({
                partnerSettings: partnerSettings, 
                subPartnerSettings: subPartnerSettings,
            }, () => {
                if( this.state.showRevshareListNonAdmin )
                    this.loadRevShares()
            })
        })
    }


    // Sub Partners CRUD
    onSubPartnersChange(event, row, index) {
        let obj = this.state.subPartnerSettings
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        obj[index][event.target.id] = value
        this.setState(obj)
    }

    onSubPartnersAdd() {
        console.log('onSubPartnersAdd')
        let obj = this.state.subPartnerSettings
        obj.push({
            new: true,
            partnerId: '',
            parentPartnerId: this.state.partnerSettings.partnerId,
            friendlyName: 'new partner name',
            canCreateChildren: true,
            region: 'us',
            cookieTypes: 'adform,ar,mobile,ip',
            partnerType: 'DATA_PROVIDER',
        })
        // dynamic update field on list: override object
        this.setState(obj)
    }

    onSubPartnerFilter(target){
        console.log("filter sub partner " + target.value)
        let search = target.value;
        this.setState({filter: search}, () => {
            this.debouncedPartnersFilter(search, 0, 5)
        })
    }
    
    onSubPartnerOnLoadMore(){
        let offset = this.state.subpartnersOffset + this.state.subpartnersSize
        this.setState({subpartnersOffset: offset, }, () => {
            this.debouncedPartnersFilter(this.state.subPartnersFilter, this.state.subpartnersOffset, this.state.subpartnersSize, false)
        })
    }
    

    onLoginAs(row, index) {
        console.log('user login as', row, index)

        let partnerMasquerading = row
        SessionService.setPartnerMasquerading(partnerMasquerading)

        this.props.history.push('/')
        window.location.reload()
    }


    onPartnerEdit(partner){
        this.props.history.push({
            pathname: `/settings/partner/edit/${partner.partnerId}`,
            state: { partner: partner }
        })
    }


    
    loadDmpList() {
        axios.get('/dmpDetails').then(response => {
            console.log('dmp list', response, response.data.body)
            this.setState({ dmpList: uniqueDmps(response.data.body, false), dmpProducts: [] }, () => {
                this.loadDmpDetails(this.state.dmpList[0].dmp)
            })
        })
    }

    loadRevShares(filter='', offset=0, size = 1000, reset = true) {
        axios
            .get(
                '/revshare?size=' +
                    size +
                    '&offset=' +
                    offset +
                    '&sort=' +
                    this.state.revshareSort +
                    '&sortOrder=' +
                    this.state.revshareSortOrder +
                    '&filter=' +
                    filter
            )
            .then(response => {
                console.log('revshare list', response, response.data.body)
                
                let revshares = [] 
                if(reset) {
                    revshares = response.data.body
                } else {
                    revshares = this.state.revshares
                    revshares = revshares.concat(response.data.body)
                }
                revshares.forEach(r => {
                    r.minPrice = parseFloat(r.minPrice / 1000000).toFixed(2)
                })
                this.setState({ revshares: revshares, loading: false }, () => {
                    this.loadDmpList()
                })
            })
    }

    
    loadDmpDetails(dmpName) {
        axios.get('/dmpDetails?dmp=' + dmpName).then(response => {
            console.log('dmp product list', response, response.data.body)
            this.setState({ dmpProducts: response.data.body }, () => {
                // update the new revshare with the first product loaded
                let revshares = this.state.revshares
                let index = revshares.findIndex(it => it.new)
                if (index != -1) {
                    console.log('update new revshare with index ', index)
                    revshares[index].product = this.state.dmpProducts[0].product
                    console.log('update new revshare with data:  ', revshares[index])
                    this.setState({ revshares: revshares })
                }
            })
        })
    }

    //
    // SELLER

    onSellerEdit(row, index) {
        console.log('onSellerEdit', row)

        // show modal for seller and loads his association with subpartners
        this.setState({ showSellerModal: true, sellerPartnerId: row.partnerId, sellerSettings: [] }, () => {
            
            axios.get('/partner?offset=0&size=10000&filter=').then(response => {
                console.log('get partner ', response.data)
    
                let data = response.data.body[0] || {}
                let subPartnerSettings = data.subPartnerSettings || []
        
                this.setState({
                    sellerPartnersList: subPartnerSettings,
                }, () => {
                    
                    axios.request({
                                url: '/seller/partner?filter=' + row.partnerId,
                                method: 'GET'
                            })
                            .then(response => {
                                console.log('onSellerEdit response', response)
                                let sellerSettings = [] // always reset data - 1 modal at a time
                                sellerSettings = response.data.body
                                this.setState({ sellerSettings: sellerSettings, loading: false })
                            })
                            
                    })
                    
                })
            })
            
            
    }

    onSellerAdd() {
        let sellerSettings = this.state.sellerSettings
        sellerSettings.push({
            partnerId: this.state.sellerPartnerId,
            revShare: 0,
            subPartnerId: null,
            isNew: true
        })
        this.setState({
            sellerSettings: sellerSettings
        })
    }

    onSellerSave(row, index) {
        console.log('save seller ', row)
        axios
            .request({
                url: '/seller/partner',
                method: row.isNew ? 'POST' : 'PATCH',
                data: {
                    partnerId: row.partnerId,
                    revShare: row.revShare,
                    subPartnerId: row.subPartnerId
                }
            })
            .then(response => {
                console.log('onSellerSave response', response)
                row.isNew = false
                //this.setState({ data: data, loading: false })
            })
    }
    onSellerRemove(row, index) {
        console.log('onSellerRemove', row, index)
        axios
            .request({
                url: '/seller/partner',
                method: 'DELETE',
                data: {
                    partnerId: row.partnerId,
                    revShare: row.revShare,
                    subPartnerId: row.subPartnerId
                }
            })
            .then(response => {
                console.log('onSellerRemove response', response)
                let sellerSettings = this.state.sellerSettings
                sellerSettings.splice(index, 1)
                this.setState({ sellerSettings: sellerSettings })
            })
    }

    render() {
        return (
            <PageWrapper>
                <Modal
                    open={this.state.showSellerModal}
                    onClose={() => this.setState({ showSellerModal: false })}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description">
                    <div style={this.state.modalStyle}>
                        <h2 id="simple-modal-title">Seller Referred subpartners</h2>
                        <p id="simple-modal-description">
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col">
                                    <div className="text-right">
                                        <button onClick={() => this.onSellerAdd()} className="border-button inlinebuttons">
                                            New
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <table className="license-list license-list--table">
                                <thead>
                                    <tr className="audience-list audience-list--header">
                                        <th className="audience-list audience-list--audience">SubPartner</th>
                                        <th className="audience-list audience-list--audience">Revshare %</th>
                                        <th className="">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.sellerSettings &&
                                        this.state.sellerSettings.map((row, index) => (
                                            <tr className={`audience-list audience-list--row }`}>
                                                <td className="audience-list audience-list--audience">
                                                    <select
                                                        className="form-control"
                                                        id="region"
                                                        value={row.subPartnerId}
                                                        onChange={event => {
                                                            let sellerSettings = this.state.sellerSettings
                                                            sellerSettings[index].subPartnerId = event.target.value
                                                            this.setState({ sellerSettings: sellerSettings })
                                                        }}>
                                                        {
                                                            this.state.sellerPartnersList
                                                                .filter(el => el.partnerType != 'SELLER')
                                                                .map(partner => <option value={partner.partnerId}>{partner.friendlyName}</option>)}
                                                    </select>
                                                </td>
                                                <td className="audience-list audience-list--size">
                                                    <input
                                                        type="number"
                                                        max="100.0"
                                                        min="0.0"
                                                        className="form-control"
                                                        id="revShare"
                                                        value={row.revShare}
                                                        onChange={event => {
                                                            let sellerSettings = this.state.sellerSettings
                                                            sellerSettings[index].revShare = event.target.value
                                                            this.setState({ sellerSettings: sellerSettings })
                                                        }}
                                                    />
                                                </td>

                                                <td className="" style={{ width: '30px' }}>
                                                    <SaveButton onClick={() => this.onSellerSave(row, index)} />
                                                    <RemoveButton onClick={() => this.onSellerRemove(row, index)} />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </p>
                    </div>
                </Modal>

                

                <div className="container-fluid">
                    <Multi>
                        {!this.state.partnerSettings ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <WhiteBox>
                                        <div className="row">
                                            <div className="col">
                                                <h3>Partner Settings</h3>
                                            </div>
                                        </div>

                                        {this.state.partnerSettings && (
                                            <div className="row" style={{ padding: '10px' }}>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="disabledTextInput">Partner ID:</label>
                                                        <input
                                                            type="text"
                                                            id="disabledTextInput"
                                                            className="form-control"
                                                            disabled={true}
                                                            value={this.state.partnerSettings.partnerId}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="disabledTextInput">Friendly Name:</label>
                                                        <input
                                                            type="text"
                                                            id="disabledTextInput"
                                                            className="form-control"
                                                            disabled={true}
                                                            value={this.state.partnerSettings.friendlyName}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </WhiteBox>

                                    {!this.state.loading &&
                                        this.state.showRevshareListNonAdmin && (
                                            <WhiteBox>
                                                <div className="row">
                                                    <div className="col">
                                                        <h3>Revenue Share</h3>
                                                    </div>
                                                </div>

                                                <RevenueShareList
                                                    editMode={false}
                                                    hasNewRows={false}
                                                    partners={this.state.partnerSettings}
                                                    list={this.state.revshares}
                                                />
                                            </WhiteBox>
                                        )}

                                    {!this.state.showRevshareListNonAdmin && (this.state.canCreateSubPartners === true || this.state.canCreateSubPartners === 1) && (
                                        <WhiteBox>
                                            <div className="row">
                                                <div className="col-12">
                                                    
                                                    {this.state.loading && <Preloader transparent />}

                                                        {this.state.partnerSettings &&
                                                            (this.state.canCreateSubPartners === true || this.state.canCreateSubPartners === 1) && (
                                                                <div
                                                                    className="tab-pane fade show active"
                                                                    id="subpartners"
                                                                    role="tabpanel"
                                                                    aria-labelledby="subpartners-tab">
                                                                    <SubPartnersList
                                                                        canCreateSubPartners={this.state.canCreateSubPartners}
                                                                        onLoginAs={this.onLoginAs.bind(this)}
                                                                        onFilterChange={this.onSubPartnerFilter.bind(this)}
                                                                        onSellerEdit={this.onSellerEdit.bind(this)}
                                                                        onLoadMore={this.onSubPartnerOnLoadMore.bind(this)}
                                                                        onEdit={this.onPartnerEdit.bind(this)}
                                                                        list={this.state.subPartnerSettings}
                                                                        offset={this.state.subpartnersOffset}
                                                                        size={this.state.subpartnersSize}
                                                                    />
                                                                </div>
                                                        )}
                                                        
                                                    </div>
                                                </div>
                                        </WhiteBox>
                                    )}
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        
    }
}

export default connect(
    state => ({}),
    mapDispatchToProps
)(Settings)
